import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  ackForgotOtpSend,
  forgotRemoveData,
  otpVerify,
  resendOtp,
} from "reduxStore/action/authActions";
import strings from "translate/language";
import { otpVerfiyValid, seo } from "utils/utils";
import AuthShell from "../AuthShell";

const Verifyotp = () => {
  const navigate = useNavigate();
  const forgotPasswordSelector =
    useSelector((state) => state.forgotPassword) || {};
  const email = forgotPasswordSelector?.data?.email || "";

  const [otpDetail, setOtpDetail] = useState({ email: "", otp: "" });
  const [errorMessage, setErrorMessage] = useState({});
  const [resendBusy, setResendBusy] = useState(false);

  const dispatch = useDispatch();

  const otpVerification = async () => {
    const { response, verifyotp = false } = forgotPasswordSelector || {};
    if (response && verifyotp) {
      if (response?.status === 200) {
        navigate("/Resetpassword");
      }
    }
  };

  useEffect(() => {
    if (forgotPasswordSelector?.otpSend) {
      dispatch(ackForgotOtpSend());
    }
  }, []);

  useEffect(() => {
    if (!email) {
      navigate("/forgotpassword", { replace: true });
      return;
    }
    setOtpDetail((prev) => ({ ...prev, email }));
  }, [email, navigate]);

  useEffect(() => {
    otpVerification();
  }, [forgotPasswordSelector]);

  const validation = () => {
    let isError = true;
    let nextErrorMessage = {};

    if (otpDetail.otp == undefined || otpDetail.otp == "") {
      isError = false;
      nextErrorMessage.otp = strings.otpErr;
    } else if (!otpVerfiyValid(otpDetail.otp)) {
      isError = false;
      nextErrorMessage.otp = strings.otpVerfiyValidErr;
    }
    setErrorMessage(nextErrorMessage);
    return isError;
  };

  const handleVerify = () => {
    if (validation()) {
      dispatch(otpVerify({ ...otpDetail, email }));
    }
  };

  const handleResendOtp = async () => {
    if (!email || resendBusy) return;
    setResendBusy(true);
    try {
      await dispatch(resendOtp({ email }));
    } finally {
      setResendBusy(false);
    }
  };

  const handleChangeEmail = () => {
    dispatch(forgotRemoveData());
    navigate("/forgotpassword");
  };

  const handleEnterPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleVerify();
    }
  };

  useEffect(() => {
    seo({
      title: "OTP",
      metaDescription: "OTP",
      canonicalLink: window.location.href,
    });
  }, []);

  const canSubmit = Boolean(String(otpDetail.otp || "").trim());

  return (
    <Fragment>
      <AuthShell
        title={strings.verifyOTP}
        subtitle={
          email
            ? `${strings.otpSentTo}: ${email}`
            : strings.enterOTPRecivedOnEmail
        }
        onBackToLogin={() => {
          dispatch(forgotRemoveData());
          navigate("/");
        }}
      >
        <form
          className="justo-login__form"
          onSubmit={(e) => {
            e.preventDefault();
            handleVerify();
          }}
        >
          <div className="justo-login__field">
            <label className="justo-login__label" htmlFor="forgot_otp">
              {strings.enterOPT}
              <span className="justo-login__required" aria-hidden="true">
                *
              </span>
            </label>
            <input
              className="form-control justo-login__input"
              id="forgot_otp"
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder={strings.enterOPT}
              value={otpDetail.otp || ""}
              onChange={(e) =>
                setOtpDetail({
                  ...otpDetail,
                  otp: e.target.value,
                  email,
                })
              }
              onKeyDown={handleEnterPress}
            />
            {errorMessage.otp ? (
              <span className="justo-login__error">{errorMessage.otp}</span>
            ) : null}
          </div>

          <div className="justo-login__actions justo-login__actions--split">
            <button
              type="button"
              onClick={handleChangeEmail}
              className="justo-login__forgot"
            >
              {strings.changeEmail}
            </button>
            <button
              type="button"
              onClick={handleResendOtp}
              className="justo-login__forgot"
              disabled={resendBusy}
            >
              {strings.resendOTP}
            </button>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block justo-login__submit"
            disabled={!canSubmit}
          >
            {strings.verify}
          </button>
        </form>
      </AuthShell>
    </Fragment>
  );
};

export default Verifyotp;
